// [MODEL-SCALARS] DateTime/Uuid/Decimal are semantic scalars so codegen can map
// them to native date/uuid/decimal types per language (GH issue #38).
export const PRIMITIVES = new Set([
    "Bool",
    "Int",
    "Float",
    "String",
    "Bytes",
    "Unit",
    "DateTime",
    "Uuid",
    "Decimal",
]);
/** [MODEL-CODEGEN-UNKNOWN] Builtin names converters understand beyond PRIMITIVES. */
export const BUILTIN_GENERICS = new Set(["List", "Map", "Option", "Any"]);
export function isTupleVariantFields(fields) {
    return fields.every((field, index) => field.name === `_${String(index)}`);
}
export function shouldEmitDeclToTarget(decl, target) {
    const whitelist = decl.targeting?.targets;
    if (whitelist !== undefined && whitelist.length > 0 && !whitelist.includes(target)) {
        return false;
    }
    return decl.targeting?.skipTargets?.includes(target) !== true;
}
export function visibleDeclsForTarget(decls, target) {
    return decls.filter((decl) => shouldEmitDeclToTarget(decl, target));
}
/** Visit every type ref in a decl, recursing into nested generic args. */
export function walkDeclRefs(d, visit) {
    if (d.kind === "record") {
        for (const f of d.fields) {
            walkRef(f.type, visit);
        }
    }
    else if (d.kind === "union") {
        for (const v of d.variants) {
            for (const f of v.fields) {
                walkRef(f.type, visit);
            }
        }
    }
    else {
        walkRef(d.target, visit);
    }
}
function walkRef(t, visit) {
    visit(t);
    for (const a of t.args) {
        walkRef(a, visit);
    }
}
/** True when any ref in any decl (incl. nested generic args) is named `name`. */
export function modelReferencesType(decls, name) {
    let found = false;
    for (const d of decls) {
        walkDeclRefs(d, (t) => {
            found = found || t.name === name;
        });
    }
    return found;
}
//# sourceMappingURL=types.js.map